<template>
  <div class="screen">
    <el-select v-model="body.sample_type" clearable placeholder="Sample Type" size="small" v-if="isShowSampleType"
               style="margin-bottom:10px; width:180px; margin-right: 10px;" :multiple="sampleTypeMultiple" collapse-tags>
      <el-option v-for="item in sampleTypeList" :key="item.value" :label="item.label"
                 :value="item.value"></el-option>
    </el-select>
    <!--    <el-select v-model="body.fg_supplier_id" clearable filterable remote size="small" style="width:150px;"-->
    <!--               placeholder="FG Supplier" :remote-method="remoteFgSupplier" :loading="fgSupplierLoading"-->
    <!--               v-if="isShowFgSupplier">-->
    <!--      <el-option v-for="item in fgSupplierList" :key="item.id" :value="item.id"-->
    <!--                 :label="item.name"></el-option>-->
    <!--    </el-select>-->
    <!--    -->
    <el-cascader v-model="body.fg_supplier_id" size="small" :options="fgSupplierList" placeholder="FG Supplier"
                 :props="{ value: 'id',label: 'name',children: 'suppliers', multiple: fgSupplierMultiple}"
                 collapse-tags clearable style="margin-right: 10px;"
                 v-if="isShowFgSupplier"></el-cascader>
    <el-cascader v-model="body.cpt_supplier_id" size="small" :options="cptSupplierList" placeholder="CPT Supplier"
                 :props="props" collapse-tags clearable style="margin-right: 10px;" v-if="isShowCptSupplier"></el-cascader>

    <el-select v-model="body.dpp" size="small" clearable placeholder="DPP" style="margin-right: 10px;" v-if="isShowDpp">
      <el-option v-for="item in dppList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select v-model="body.passion_brand" clearable placeholder="Brand" size="small" style="width:150px; margin-right: 10px;"
               @visible-change="showBrand" v-if="isShowBrand">
      <el-option v-for="item in passionBrand" :key="item" :value="item" :label="item"></el-option>
    </el-select>
    <el-select v-model="body.season" clearable placeholder="Season" size="small" style="width:150px;margin-right: 10px; margin-bottom: 10px;"
               @visible-change="showSeason" v-if="isShowSeason">
      <el-option v-for="item in seasonList" :key="item" :value="item" :label="item"></el-option>
    </el-select>
    <el-select v-model="statusValue" clearable placeholder="Status" size="small" style="width:150px;margin-right: 10px;"
               @change="changeStatus" v-if="isShowStatus">
      <el-option v-for="item in statusList" :key="item.value" :value="item.value"
                 :label="item.label"></el-option>
    </el-select>
    <el-select v-model="body.is_ttm" clearable placeholder="TTM" size="small" style="width:150px;margin-right: 10px;"
               v-if="isShowTtm">
      <el-option v-for="item in [{label:'Y', value: 1},{label:'N', value: 0}]" :key="item.value"
                 :value="item.value" :label="item.label"></el-option>
    </el-select>
    <div style="margin-right: 10px;" v-if="isShowTimeSlot">
      <span style="margin-right: 5px;" v-if="timeSlotTitle">{{ timeSlotTitle }}</span>
      <el-date-picker v-model="timeSlot" type="daterange" size="small" :start-placeholder="timeSlotPlaceholder + ' Start Date'"
                    :end-placeholder="timeSlotPlaceholder + ' End Date'" :picker-options="pickerDisabled" @change="changeTimeRange" :clearable="false"
                    ></el-date-picker>
    </div>
    <el-select v-model="dateType" size="small" style="width: 100px; margin-right: 10px;" @change="changeDateType" v-if="showDateType">
      <el-option value="etd" label="ETD"></el-option>
      <el-option value="po" label="PO"></el-option>
    </el-select>
    <el-date-picker v-model="poSlot" type="daterange" size="small" :start-placeholder="poSlotPlaceholder + ' Start Date'"
                    :end-placeholder="poSlotPlaceholder + ' End Date'" @change="changePORange" style="margin-right: 10px;" v-if="isShowPoSlot"></el-date-picker>
    <el-input v-model="body.keyword" clearable placeholder="Search" size="small" style="width:150px;margin-right: 10px;"
              v-if="isShowSearch"></el-input>
    <el-button type="primary" size="mini" @click="search" style="margin-right: 10px; height: 34px;">Search</el-button>
    <el-button type="success" @click="send" size="mini" v-if="isShowSend" style="margin-right: 10px;height: 34px;">Send</el-button>
    <el-button type="primary" size="mini" @click="exportFile" v-if="isExport" style="margin-right: 10px; height: 34px;">Export</el-button>
    <el-button type="primary" size="mini" :disabled="!multipleSelection.length"  style="margin-right: 10px; " @click="exportFileBySelect"
               v-if="!display && isExportBySelect">
      Export By Select
    </el-button>
    <el-button type="primary" size="mini" @click="clickETD" style="margin-right: 10px;height: 34px;" v-if="isShowEtdBtn">
      {{activeName === 2 ? 'Update ETD':'ETD'}}
    </el-button>
    <el-button type="primary" size="mini" @click="clickWaybill" style="margin-right: 10px;height: 34px;" v-if="isShowWaybill">
      Courrier Number
    </el-button>
    <el-button type="primary" size="mini" @click="clickUpdateReason" style="margin-right: 10px;height: 34px;" v-if="isUpdateReason">
      Update Reason
    </el-button>
    <el-button type="primary" size="mini" @click="sapImport" :loading="importBtnLoading" style="margin-right: 10px;height: 34px;" v-if="isShowImport">
      Import
    </el-button>
    <el-button type="primary" size="mini" @click="clickReplyToEtd" style="margin-right: 10px;height: 34px;" v-if="isShowReplyToEtd">Reply to ETD</el-button>
    <el-button type="primary" size="mini" @click="clickUploadToETD" style="margin-right: 10px;height: 34px;" :loading="importETDLoading" v-if="isShowUploadEtd">
      Import
    </el-button>
    <el-button type="text" @click="downloadTemplate" style="margin-right: 10px;height: 34px;" v-if="isShowOrderTemplateDownload">
      Order template download
    </el-button>

    <input type="file" id="fileElem" style="display:none" @change="handleFiles"/>
    <input type="file" id="fileETD" style="display:none" @change="handleETDFiles"/>

    <slot></slot>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    props: {
      sampleTypeList: {
        type: Array
      },
      sampleTypeMultiple: {
        type: Boolean
      },
      cptSupplierList: {
        type: Array
      },
      display: {
        type: Number,
        default: 0
      },
      isShowStatus: {
        type: Boolean,
        default: false
      },
      params: {
        type: Object,
      },
      multipleSelection: {
        type: Array,
        default: () => {
          return []
        }
      },
      isShowCptSupplier: {
        type: Boolean,
        default: true
      },

      isShowFgSupplier: {
        type: Boolean,
        default: true
      },

      fgSupplierMultiple: {
        type: Boolean
      },

      isShowEtdBtn: {
        type: Boolean,
        default: false
      },
      activeName: {
        type: Number,
      },
      isShowWaybill: {
        type: Boolean,
        default: false
      },
      isExport: {
        type: Boolean,
        default: true
      },
      isExportBySelect: {
        type: Boolean,
        default: true
      },
      isUpdateReason: {
        type: Boolean,
        default: false
      },
      isShowSend: {
        type: Boolean,
        default: false
      },
      isShowImport: {
        type: Boolean,
        default: false
      },
      isShowOrderTemplateDownload: {
        type: Boolean,
        default: false
      },
      isShowSearch: {
        type: Boolean,
        default: true
      },
      isShowTimeSlot: {
        type: Boolean,
        default: false
      },
      timeSlotTitle: {
        type: String,
        default: ''
      },
      timeSlotPlaceholder: {
        type: String,
        default: ''
      },
      isShowReplyToEtd: {
        type: Boolean,
        default: false
      },
      isShowSampleType: {
        type: Boolean,
        default: false
      },
      isShowBrand: {
        type: Boolean,
        default: false
      },
      isShowSeason: {
        type: Boolean,
        default: false
      },
      isCustomExportFile: {
        type: Boolean,
        default: false
      },
      isShowUploadEtd: {
        type: Boolean,
        default: false
      },
      isShowDpp: {
        type: Boolean,
        default: false
      },
      isShowPoSlot: {
        type: Boolean,
        default: false
      },

      poSlotPlaceholder: {
        type: String,
        default: 'PO'
      },

      isShowTtm: {
        type: Boolean,
        default: false
      },
      showDateType: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        body: {
          sample_type: '',
          fg_supplier_id: '',
          cpt_supplier_id: [],
          passion_brand: '',
          keyword: '',
          dpp: '',
          is_ttm: '',
        },
        fgSupplierLoading: false,
        fgSupplierList: [],
        props: {
          multiple: true,
          value: 'id',
          label: 'name',
          children: 'suppliers'
        },
        passionBrand: [],
        seasonList: [],
        statusValue: '',
        statusList: [{
          value: 0,
          status: 1,
          type: 2,
          label: 'Untreated'
        }, {
          value: 1,
          status: 1,
          type: 3,
          label: 'Processed'
        }, {
          value: 2,
          status: '',
          type: 4,
          label: 'Cancel Request'
        }, {
          value: 3,
          status: 2,
          type: '',
          label: 'Pending'
        }, {
          value: 4,
          status: 4,
          type: '',
          label: 'Potential Delay'
        }, {
          value: 5,
          status: 3,
          type: '',
          label: 'Closed'
        }, {
          value: 6,
          status: 5,
          type: '',
          label: 'Cancelled'
        }],
        importBtnLoading: false,
        itemList: [],
        url: '',
        importETDLoading: false,
        dppList: [],
        poSlot: [],
        timeSlot: [],
        pickerDisabled: {
          disabledDate: (time) => {
            let nowTemp = new Date();//当前时间
            let oneDayLong = 24 * 60 * 60 * 1000;//一天的毫秒数
            let c_time = nowTemp.getTime();//当前时间的毫秒时间
            let c_day = nowTemp.getDay() || 7;//当前时间的星期几
            let m_time = c_time - (c_day - 1) * oneDayLong;
            console.log('时间', time, new Date(m_time - oneDayLong));
            return time.getTime() > new Date(m_time - oneDayLong).getTime();
          }
        },
        dateType: 'etd',
      }
    },

    methods: {
      changeDateType(e) {
        console.log(e)
        this.$emit('changeDateType', e)
      },
      // 远程搜索 FG Supplier
      remoteFgSupplier: throttle(function (query) {
        if (query !== "") {
          this.fgSupplierLoading = true;
          this.$api.supplierFg({keyword: query}).then(res => {
            this.fgSupplierList = res.data;
            this.fgSupplierLoading = false;
          });
        }
      }, 2000),

      initPoSlot(startDate, endDate, isDisable) {
        this.timeSlot = [new Date(startDate), new Date(endDate)]
      },

      showBrand(e) {
        if (e && !this.passionBrand.length) {
          this.$api.orderItemSelectPassionBrand().then(res => {
            this.passionBrand = res.data;
          });
        }
      },

      showSeason(e) {
        if (e && !this.seasonList.length) {
          this.getSeason();
        }
      },

      // 获取 Season
      getSeason() {
        if (this.display) {
          this.$api.orderSelectSeason().then(res => {
            this.seasonList = res.data;
          });
        } else {
          this.$api.orderItemSelectSeason().then(res => {
            this.seasonList = res.data;
          });
        }
      },

      //  选择status后参数处理
      changeStatus(e) {
        console.log(e);
        if (e) {
          this.body.status = this.statusList[e].status;
          this.body.type = this.statusList[e].type;
        } else {
          this.body.status = '';
          this.body.type = '';
        }
      },

      // 获取DPP列表
      getDpp() {
        this.$api.orgAll().then(res => {
          this.dppList = res.data;
        });
      },

      // 点击search
      search() {
        let params = this.handelParamsOfFatherView();
        console.log(params);
        this.$emit('search', params)
      },

      // 向父集传值时处理CPT Supplier参数
      handelParamsOfFatherView() {
        let params = {};
        for (let key in this.body) {
          if (!this.body.hasOwnProperty(key)) continue;
          if (key !== 'cpt_supplier_id' && !(this.fgSupplierMultiple && key === 'fg_supplier_id')) {
            if (key === 'fg_supplier_id') {
              if (this.body[key][1]) {
                params[key] = this.body[key][1] ? [this.body[key][1]] : ['']
              }
            } else {
              params[key] = this.body[key]
            }
          } else {
            params[key] = [];
            for (let i = 0; i < this.body[key].length; i++) {
              let element = this.body[key][i];
              params[key].push(element[1]);
            }
          }
        }
        if (this.isShowPoSlot) {
          if (this.poSlot && this.poSlot.length) {
            params.created_date_from = moment(this.poSlot[0]).format('YYYY-MM-DD');
            params.created_date_to = moment(this.poSlot[1]).format('YYYY-MM-DD');
          } else {
            params.created_date_from = '';
            params.created_date_to = '';
          }
        }
        if (this.isShowTimeSlot) {
          if (this.timeSlot && this.timeSlot.length) {
            params.start_time = moment(this.timeSlot[0]).format('YYYY-MM-DD');
            params.end_time = moment(this.timeSlot[1]).format('YYYY-MM-DD');
          } else {
            params.start_time = '';
            params.end_time = '';
          }
        }
        return params
      },

      // 下载
      exportFile() {
        let params = {...this.params, ...this.body};
        if (this.isShowPoSlot) {
          if (this.poSlot && this.poSlot.length) {
            params.created_date_from = moment(this.poSlot[0]).format('YYYY-MM-DD');
            params.created_date_to = moment(this.poSlot[1]).format('YYYY-MM-DD');
          } else {
            params.created_date_from = '';
            params.created_date_to = '';
          }
        }
        if (!Number(this.display)) {
          params['time_type'] = this.dateType;
        }
        let paramsStr = '';
        for (const key in params) {
          if (params.hasOwnProperty(key)) {
            if (key === 'page' || key === 'limit') {
              continue;
            }
            if (key === 'cpt_supplier_id') {
              for (let i = 0; i < params[key].length; i++) {
                paramsStr += `&${key}[]=${params[key][i][1]}`
              }
              continue;
            }
            if (key === 'fg_supplier_id') {
              if (this.fgSupplierMultiple) {
                for (let i = 0; i < params[key].length; i++) {
                  paramsStr += `&${key}[]=${params[key][i][1]}`
                }
              } else {
                if (this.body['fg_supplier_id'].length) {
                  paramsStr += `&${key}=${this.body[key][1]}`
                } else {
                  paramsStr += `&${key}=${params[key]}`
                }
              }
              continue;
            }
            paramsStr += `&${key}=${params[key]}`
          }
        }
        if (this.isCustomExportFile) {
          this.$emit('exportFile', paramsStr);
          return;
        }
        let url = '';
        if (!Number(this.display)) {
          url += this.$config.apiURL + 'api/orderItem/list'
        } else {
          url += this.$config.apiURL + 'api/order/list'
        }
        url += `?token=${this.$storage.get('userInfo')['access_token']}&export=1`;

        url += paramsStr;
        window.open(url);
      },

      // 选择下载
      exportFileBySelect() {
        if (this.isCustomExportFile) {
          this.$emit('exportFileBySelect', paramsStr);
          return;
        }
        let url = this.$config.apiURL + 'api/orderItem/exportSelectItem';
        url += `?token=${this.$storage.get('userInfo')['access_token']}&export=1`;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          url += `&item_id[${i}]=${this.multipleSelection[i].id}`
        }
        window.open(url);
      },

      clickETD() {
        this.$emit('clickETD');
      },

      clickWaybill() {
        this.$emit('clickWaybill')
      },

      clickUpdateReason() {
        this.$emit('clickUpdateReason');
      },

      send() {
        this.$emit('send')
      },

      // 点击上传
      sapImport() {
        document.getElementById("fileElem").click();
      },

      downloadTemplate() {
        this.$emit('downloadTemplate');
      },

      handleFiles(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) {
          return;
        }
        let formData = new FormData();
        formData.append("import_file", files[0]);
        this.importBtnLoading = true;
        this.$api.orderItemImport(formData).then(res => {
          this.$notify({
            type: "success",
            message: "Success"
          });
          this.importBtnLoading = false;
          let input = document.getElementById("fileElem");
          input.value = "";
          this.$storage.remove("import_file");
          this.$storage.set("import_file", res.data);
          this.$router.push({
            path: "/orderManage/edit?status=0"
          });
        }, () => {
          let input = document.getElementById("fileElem");
          input.value = "";
          this.importBtnLoading = false;
        });
      },

      changeTimeRange(e) {
        this.$emit('changeTimeRange', e)
      },

      changePORange(e) {

      },

      clickReplyToEtd() {
        this.$emit('clickReplyToEtd');
      },

      // 上传Upload文件
      clickUploadToETD() {
        document.getElementById("fileETD").click();
      },

      handleETDFiles(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) {
          return;
        }
        let formData = new FormData();
        formData.append("import_file", files[0]);
        this.importETDLoading = true;
        this.$api.orderImportEtdByExcel(formData).then(() => {
          this.$notify({
            type: "success",
            message: "Success"
          });
          this.importETDLoading = false;
          let input = document.getElementById("fileETD");
          input.value = "";
          this.$emit('uploadETD');
        }, () => {
          let input = document.getElementById("fileETD");
          input.value = "";
          this.importETDLoading = false;
        });
      }
    }
  }

  function throttle(func, delay) {
    let prev = Date.now();
    return function () {
      let context = this;
      let args = arguments;
      let now = Date.now();
      if (now - prev >= delay) {
        func.apply(context, args);
        prev = Date.now();
      }
    };
  }
</script>

<style lang="scss">
  .screen {
    margin-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/screen.vue